const IMG = {
  idraulico:
    "https://images.unsplash.com/photo-1676210134050-6f12c6898395?crop=entropy&cs=srgb&fm=jpg&q=85",
  fabbro:
    "https://images.unsplash.com/photo-1553873002-785d775854c9?crop=entropy&cs=srgb&fm=jpg&q=85",
  elettricista:
    "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const CATEGORIA_INFO = {
  idraulico: { nome: "Idraulico", immagine: IMG.idraulico },
  fabbro: { nome: "Fabbro", immagine: IMG.fabbro },
  elettricista: { nome: "Elettricista", immagine: IMG.elettricista },
};

const PUNTI_STD = [
  "Preventivo chiaro prima dei lavori",
  "Attivi 24 ore su 24, festivi inclusi",
];

export const SOTTOPAGINE = {
  idraulico: {
    "stasatura-tubi": {
      voceMenu: "Stasatura tubi intasati",
      titolo: "Stasatura tubi intasati in Lombardia",
      intro:
        "L'acqua non scende più, il lavandino gorgoglia, il wc rischia di tracimare: i nostri idraulici liberano tubazioni domestiche e colonne condominiali in tutta la Lombardia, a qualsiasi ora.",
      passi: [
        { t: "Diagnosi dell'ostruzione", d: "Capiamo dove si è formato il tappo: sifone, tubatura orizzontale o colonna di scarico." },
        { t: "Disostruzione meccanica", d: "Interveniamo con sonde a molla professionali che rispettano le tubature, anche quelle più vecchie." },
        { t: "Lavaggio ad alta pressione", d: "Se serve, laviamo la tubazione in pressione per eliminare incrostazioni e residui." },
        { t: "Verifica finale", d: "Controlliamo il flusso e ti diciamo come evitare che il problema torni." },
      ],
      punti: ["Nessuno smontaggio inutile: prima la sonda, poi il resto", "Attrezzatura professionale sempre a bordo", ...PUNTI_STD],
    },
    allagamenti: {
      voceMenu: "Allagamenti",
      titolo: "Allagamenti: pronto intervento H24 in Lombardia",
      intro:
        "Un tubo rotto o una lavatrice che perde possono allagare casa in pochi minuti. La nostra squadra arriva subito: chiude l'acqua, prosciuga e mette in sicurezza, poi ripara la causa.",
      passi: [
        { t: "Chiusura dell'acqua", d: "Prima cosa: fermiamo il flusso alla fonte per bloccare l'avanzata dell'acqua." },
        { t: "Prosciugamento", d: "Rimuoviamo l'acqua dai locali con pompe e aspiraliquidi professionali." },
        { t: "Messa in sicurezza", d: "Verifichiamo impianto elettrico e strutture prima di riaccendere tutto." },
        { t: "Riparazione della causa", d: "Troviamo e ripariamo il punto di rottura, così l'allagamento non si ripete." },
      ],
      punti: ["Intervento d'urgenza per limitare i danni", "Pompe e aspiraliquidi sempre sui mezzi", ...PUNTI_STD],
    },
    "rubinetteria-sanitari": {
      voceMenu: "Rubinetteria e sanitari",
      titolo: "Rubinetteria e sanitari: riparazione H24 in Lombardia",
      intro:
        "Rubinetti che gocciolano, cassette wc che non caricano, sanitari che perdono: piccoli guasti che consumano acqua e pazienza. I nostri idraulici li risolvono in un'unica uscita, in tutta la Lombardia.",
      passi: [
        { t: "Diagnosi del guasto", d: "Identifichiamo il componente usurato: cartuccia, guarnizioni, galleggiante o raccordi." },
        { t: "Smontaggio pulito", d: "Lavoriamo con cura su rubinetteria e sanitari senza rovinare finiture e piastrelle." },
        { t: "Sostituzione ricambi", d: "Montiamo ricambi originali o equivalenti di qualità, già disponibili a bordo." },
        { t: "Collaudo finale", d: "Testiamo portata e tenuta prima di andarcene: niente più gocce." },
      ],
      punti: ["Ricambi a bordo per le marche più diffuse", "Lavoro pulito e rapido, in un'unica uscita", ...PUNTI_STD],
    },
    "scaldabagno-boiler": {
      voceMenu: "Scaldabagno e boiler",
      titolo: "Scaldabagno e boiler: assistenza H24 in Lombardia",
      intro:
        "Restare senz'acqua calda è un'emergenza vera, soprattutto d'inverno. I nostri tecnici riparano o sostituiscono scaldabagni elettrici e a gas in tutta la Lombardia, giorno e notte.",
      passi: [
        { t: "Diagnosi del guasto", d: "Resistenza, termostato, termocoppia o pressione: troviamo subito il componente in avaria." },
        { t: "Riparazione sul posto", d: "Sostituiamo il componente guasto con ricambi a bordo per le marche più comuni." },
        { t: "Sostituzione se conviene", d: "Se la riparazione non conviene, ti proponiamo la sostituzione con prezzo chiaro in anticipo." },
        { t: "Prova acqua calda", d: "Prima di andarcene verifichiamo temperatura e tenuta: la doccia torna calda." },
      ],
      punti: ["Scaldabagni elettrici e a gas, tutte le marche", "Ricambi a bordo per l'80% dei guasti", ...PUNTI_STD],
    },
  },
  fabbro: {
    "apertura-porte-bloccate": {
      voceMenu: "Apertura porte bloccate",
      titolo: "Apertura porte bloccate in Lombardia",
      intro:
        "Sei rimasto fuori casa o il negozio non si apre? I nostri fabbri aprono porte blindate e semplici senza scasso nella maggior parte dei casi, in tutta la Lombardia, giorno e notte.",
      passi: [
        { t: "Valutazione della serratura", d: "Tipo di porta e cilindro determinano la tecnica: prima valutiamo, poi apriamo." },
        { t: "Apertura senza scasso", d: "Con strumenti professionali apriamo senza danneggiare porta e serratura, nella maggior parte dei casi." },
        { t: "Controllo del meccanismo", d: "Verifichiamo perché si è bloccata e ti diciamo se serve manutenzione o sostituzione." },
        { t: "Consegna e consigli", d: "Ti lasciamo la porta funzionante e i consigli per non restare di nuovo chiuso fuori." },
      ],
      punti: ["Senza scasso quando possibile", "Porte blindate e semplici", ...PUNTI_STD],
    },
    "cambio-serrature": {
      voceMenu: "Cambio serrature",
      titolo: "Cambio serrature in Lombardia",
      intro:
        "Chiavi perse, trasloco, tentativo di effrazione: cambiare serratura è questione di minuti con i nostri fabbri. Installiamo cilindri europei e serrature di sicurezza in tutta la Lombardia.",
      passi: [
        { t: "Scelta del cilindro", d: "Ti proponiamo cilindri europei anti-bumping e anti-trapano, spiegandoti le differenze." },
        { t: "Rimozione della vecchia serratura", d: "Smontiamo la serratura esistente senza danneggiare la porta." },
        { t: "Montaggio e conversione", d: "Installiamo il nuovo cilindro o convertiamo la serratura da doppia mappa a europea." },
        { t: "Prova e consegna chiavi", d: "Testiamo apertura e chiusura e ti consegniamo le nuove chiavi sigillate." },
      ],
      punti: ["Cilindri europei anti-bumping", "Anche dopo furto o smarrimento chiavi", ...PUNTI_STD],
    },
    "serrande-tapparelle": {
      voceMenu: "Serrande e tapparelle",
      titolo: "Riparazione serrande e tapparelle in Lombardia",
      intro:
        "Una serranda bloccata ferma il tuo negozio, una tapparella rotta blocca casa tua. Interveniamo su molle, cinghie, rulli e motori in tutta la Lombardia, anche di notte.",
      passi: [
        { t: "Sblocco immediato", d: "Riapriamo la serranda o la tapparella per rimetterti in attività subito." },
        { t: "Sostituzione componenti", d: "Molle, cinghie, rulli o motore: sostituiamo ciò che è usurato con ricambi a bordo." },
        { t: "Messa in sicurezza", d: "Verifichiamo guide e fermi per evitare cedimenti pericolosi." },
        { t: "Collaudo", d: "Apriamo e chiudiamo più volte per garantire scorrimento fluido e silenzioso." },
      ],
      punti: ["Anche serrande motorizzate", "Ricambi sempre a bordo", ...PUNTI_STD],
    },
    "cancelli-inferriate": {
      voceMenu: "Cancelli e inferriate",
      titolo: "Cancelli e inferriate: riparazione in Lombardia",
      intro:
        "Cancello che non si chiude, inferriata staccata, cardine ceduto: ripariamo e saldiamo sul posto cancelli, inferriate e grate di sicurezza in tutta la Lombardia.",
      passi: [
        { t: "Sopralluogo e messa in sicurezza", d: "Blocchiamo la struttura per lavorare in sicurezza ed evitare crolli." },
        { t: "Riparazione o saldatura sul posto", d: "Saldiamo cardini e giunti direttamente sul posto, senza smontare il cancello." },
        { t: "Regolazione e lubrificazione", d: "Riallineiamo l'anta e lubrifichiamo i punti di scorrimento." },
        { t: "Prova di funzionamento", d: "Testiamo apertura, chiusura e blocco prima di andarcene." },
      ],
      punti: ["Saldatura direttamente sul posto", "Cancelli manuali e automatici", ...PUNTI_STD],
    },
    "chiave-rotta-nella-serratura": {
      voceMenu: "Chiave rotta nella serratura",
      titolo: "Chiave rotta nella serratura in Lombardia",
      intro:
        "La chiave si è spezzata dentro la serratura? Non forzare: rischi di peggiorare. I nostri fabbri estraggono il frammento senza rovinare il cilindro e, se serve, lo sostituiscono subito.",
      passi: [
        { t: "Valutazione del cilindro", d: "Controlliamo posizione del frammento e stato della serratura prima di intervenire." },
        { t: "Estrazione del frammento", d: "Estraiamo la chiave spezzata con strumenti dedicati, senza rovinare il cilindro." },
        { t: "Controllo o sostituzione", d: "Se il cilindro è usurato te lo diciamo e lo sostituiamo subito, con prezzo chiaro." },
        { t: "Prova con la chiave", d: "Verifichiamo più volte apertura e chiusura con la chiave di scorta o nuova." },
      ],
      punti: ["Estrazione senza danni nella maggior parte dei casi", "Cilindro nuovo subito disponibile", ...PUNTI_STD],
    },
  },
  elettricista: {
    "cortocircuito-salvavita": {
      voceMenu: "Cortocircuito e salvavita",
      titolo: "Cortocircuito e salvavita: intervento H24 in Lombardia",
      intro:
        "Il salvavita scatta in continuazione e la casa resta al buio? Individuiamo il cortocircuito con strumenti di misura professionali e riportiamo l'impianto in sicurezza, in tutta la Lombardia.",
      passi: [
        { t: "Messa in sicurezza", d: "Togliamo tensione alle linee a rischio prima di qualsiasi intervento." },
        { t: "Ricerca del cortocircuito", d: "Con tester e strumenti di misura troviamo il punto esatto del guasto." },
        { t: "Riparazione del punto guasto", d: "Ripariamo o isoliamo la linea difettosa e sostituiamo i componenti bruciati." },
        { t: "Riarmo e verifica", d: "Riarmiamo il salvavita e testiamo l'impianto sotto carico." },
      ],
      punti: ["Strumentazione di misura professionale", "Impianto lasciato in sicurezza", ...PUNTI_STD],
    },
    "guasti-black-out": {
      voceMenu: "Guasti e black-out",
      titolo: "Guasti e black-out elettrici in Lombardia",
      intro:
        "Corrente che va e viene, stanze senza luce, prese morte: troviamo il guasto nell'impianto e ripristiniamo l'alimentazione, anche parziale, per farti ripartire subito.",
      passi: [
        { t: "Analisi del quadro", d: "Controlliamo interruttori e differenziali per capire quale linea è in avaria." },
        { t: "Isolamento della linea guasta", d: "Isoliamo la parte di impianto danneggiata per ripristinare il resto." },
        { t: "Ripristino alimentazione", d: "Riportiamo la corrente dove serve, anche con soluzioni temporanee sicure." },
        { t: "Verifica dei carichi", d: "Controlliamo che l'impianto regga l'uso quotidiano senza nuovi distacchi." },
      ],
      punti: ["Elettricisti certificati e assicurati", "Ripristino anche parziale e immediato", ...PUNTI_STD],
    },
    "quadri-elettrici": {
      voceMenu: "Quadri elettrici",
      titolo: "Quadri elettrici: messa a norma in Lombardia",
      intro:
        "Quadro vecchio, magnetotermici che saltano, differenziale assente: mettiamo a norma e in sicurezza il quadro elettrico di case, uffici e negozi in tutta la Lombardia.",
      passi: [
        { t: "Verifica del quadro esistente", d: "Controlliamo lo stato di interruttori, morsetti e sezionatori." },
        { t: "Sostituzione interruttori", d: "Montiamo magnetotermici nuovi, dimensionati sul tuo impianto." },
        { t: "Installazione differenziale", d: "Aggiungiamo o sostituiamo il salvavita per la protezione delle persone." },
        { t: "Collaudo finale", d: "Testiamo ogni linea e ti consegniamo il quadro etichettato e in ordine." },
      ],
      punti: ["Quadri per case, uffici e negozi", "Materiali a norma CE", ...PUNTI_STD],
    },
    "prese-interruttori": {
      voceMenu: "Prese e interruttori",
      titolo: "Prese e interruttori: riparazione in Lombardia",
      intro:
        "Una presa che non funziona o un interruttore che scotta non vanno ignorati. Sostituiamo frutti, placche e punti luce in modo rapido e pulito, in tutta la Lombardia.",
      passi: [
        { t: "Controllo del punto luce", d: "Verifichiamo se il problema è nel frutto, nei collegamenti o nella linea." },
        { t: "Sostituzione del frutto", d: "Montiamo prese e interruttori nuovi, compatibili con la tua serie civile." },
        { t: "Verifica messa a terra", d: "Controlliamo che la terra sia presente e funzionante, per la tua sicurezza." },
        { t: "Prova finale", d: "Testiamo ogni punto sostituito prima di chiudere il lavoro." },
      ],
      punti: ["Compatibili con tutte le serie civili", "Lavoro pulito e veloce", ...PUNTI_STD],
    },
    "ripristino-corrente": {
      voceMenu: "Ripristino corrente",
      titolo: "Ripristino corrente H24 in Lombardia",
      intro:
        "Black-out totale in casa o in azienda? La nostra squadra elettrica interviene a qualsiasi ora per riportare la corrente, individuando la causa tra contatore, quadro e linee.",
      passi: [
        { t: "Verifica contatore e quadro", d: "Capiamo se l'interruzione viene da fuori o dal tuo impianto." },
        { t: "Ricerca della causa", d: "Controlliamo linee e apparecchi per trovare cosa ha fatto saltare tutto." },
        { t: "Ripristino progressivo", d: "Riattiviamo le linee una alla volta, in sicurezza." },
        { t: "Controllo finale", d: "Verifichiamo tensione e protezioni prima di andarcene." },
      ],
      punti: ["Anche di notte e nei festivi", "Per case, uffici e negozi", ...PUNTI_STD],
    },
  },
};

export const VOCE_A_PAGINA = {
  idraulico: {
    "Perdite d'acqua": "/servizi/idraulico/perdita-acqua",
    "Stasatura tubi intasati": "/servizi/idraulico/stasatura-tubi",
    Allagamenti: "/servizi/idraulico/allagamenti",
    "Rubinetteria e sanitari": "/servizi/idraulico/rubinetteria-sanitari",
    "Scaldabagno e boiler": "/servizi/idraulico/scaldabagno-boiler",
  },
  fabbro: {
    "Apertura porte bloccate": "/servizi/fabbro/apertura-porte-bloccate",
    "Cambio serrature": "/servizi/fabbro/cambio-serrature",
    "Serrande e tapparelle": "/servizi/fabbro/serrande-tapparelle",
    "Cancelli e inferriate": "/servizi/fabbro/cancelli-inferriate",
    "Chiave rotta nella serratura": "/servizi/fabbro/chiave-rotta-nella-serratura",
  },
  elettricista: {
    "Cortocircuito e salvavita": "/servizi/elettricista/cortocircuito-salvavita",
    "Guasti e black-out": "/servizi/elettricista/guasti-black-out",
    "Quadri elettrici": "/servizi/elettricista/quadri-elettrici",
    "Prese e interruttori": "/servizi/elettricista/prese-interruttori",
    "Ripristino corrente": "/servizi/elettricista/ripristino-corrente",
  },
};
